import React from 'react';
import {NavTabs} from '~/components/Tabs';
import {biddersLinks} from '~/modules/Bidders';

export const BiddersTypeNavigation = () => (
    <NavTabs
        tabs={[
            {
                children: 'Bidders',
                to: biddersLinks.bidders(),
                end: true,
            },
            {
                children: 'Bidder groups',
                to: biddersLinks.bidderGroups(),
            },
        ]}
    />
);
